// Field sizing for a full-screen form that was a drawer (KAN-1075). The drawer's field-height rule
// (drawerFields.css, KAN-810: 40px web / 44px touch for inputs, selects, filter triggers and money
// fields) is scoped to `.cvx-drawer-body`; the form frame has no such class, so the moved forms
// wrap their cards here to keep exactly the field sizes they had. `display: contents` adds no box.
import '../drawer/drawerFields.css';

export default function FormFieldScope({ touch, children }) {
  return (
    <div className="cvx-drawer-body" data-touch={touch ? 'true' : 'false'} style={{ display: 'contents' }}>
      {children}
    </div>
  );
}
